import {Model} from "@vuex-orm/core";

export default class WebsitePackageWebsiteCategory extends Model {

    static entity = 'WebsitePackageWebsiteCategory';

    static primaryKey = ['website_package_id', 'website_category_id'];

    static fields () {
        return {
            website_package_id: this.number(null).nullable(),
            website_category_id: this.number(null).nullable(),
        }
    }
}
